import { CommonModule } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Component({
  selector: "v2m-appointment",
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule],
  templateUrl: "./appointment.component.html",
  styleUrls: ["./appointment.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppointmentComponent {
  apiUrl = "https://api.video2manual.de/newsletters/register";
  salutation = "";
  lastname = "";
  firstname = "";
  email = "";
  phone = "";
  privacy = false;
  isSending = false;
  isSended = false;
  monday = true;
  tuesday = true;
  wednesday = true;
  thursday = true;
  morning = true;
  afternoon = true;

  constructor(private http: HttpClient) {}

  send() {
    let days = "";
    if (this.monday) days += "Montag, ";
    if (this.tuesday) days += "Dienstag, ";
    if (this.wednesday) days += "Mittwoch, ";
    if (this.thursday) days += "Donnerstag, ";
    if (this.morning) days += "Vormittag, ";
    if (this.afternoon) days += "Nachmittag, ";
    const request = {
      Email: this.email,
      Salutation: this.salutation,
      FirstName: this.firstname,
      LastName: this.lastname,
      Phone: this.phone,
      CompanyName: days,
      RegistrationMethod: "Website",
    };

    this.isSending = true;

    this.http.post(this.apiUrl, request, httpOptions).subscribe((_) => {
      this.isSending = false;
      this.isSended = true;
    });
  }
}
